import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 * Google Podcasts icon.
 */
const GooglePodcasts = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 25 25"
    {...props}
    className={cn('w-full', props.className)}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#FAB908" d="M11 8v9h3V8z" />
      <path
        fill="#0066D9"
        d="M1.547 9.984a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 0-3.095"
      />

      <path
        fill="#0066D9"
        d="M1.547 11.672a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 0-3.095"
      />

      <path fill="#0066D9" d="M0 13.219h3.094V11.53H0z" />
      <path
        fill="#4285F4"
        d="M23.203 11.672a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095"
      />

      <path
        fill="#4285F4"
        d="M23.203 9.984a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095"
      />

      <path fill="#4285F4" d="M21.656 13.219h3.094V11.53h-3.094z" />
      <path
        fill="#EA4335"
        d="M6.89 15.047a1.547 1.547 0 1 1 0 3.093 1.547 1.547 0 0 1 0-3.093"
      />

      <path
        fill="#EA4335"
        d="M6.89 16.734a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094"
      />

      <path
        fill="#EA4335"
        d="M5.344 18.281h3.093v-1.687H5.345zM6.89 4.922a1.547 1.547 0 1 1 0 3.095 1.547 1.547 0 0 1 0-3.095m0 5.484a1.547 1.547 0 1 1 0 3.095 1.547 1.547 0 0 1 0-3.095"
      />

      <path fill="#EA4335" d="M5.344 11.988h3.093v-5.52H5.345z" />
      <path
        fill="#34A853"
        d="M17.86 6.61a1.547 1.547 0 1 1-.002 3.094 1.547 1.547 0 0 1 .001-3.095"
      />

      <path
        fill="#34A853"
        d="M17.86 4.922a1.547 1.547 0 1 1-.002 3.095 1.547 1.547 0 0 1 .001-3.095"
      />

      <path fill="#34A853" d="M16.313 8.156h3.093V6.47h-3.093z" />
      <path
        fill="#FAB908"
        d="M12.375 1.688a1.547 1.547 0 1 1-.001 3.094 1.547 1.547 0 0 1 .001-3.095"
      />

      <path
        fill="#FAB908"
        d="M12.375 0a1.547 1.547 0 1 1-.001 3.095A1.547 1.547 0 0 1 12.375 0"
      />

      <path
        fill="#FAB908"
        d="M10.828 3.234h3.094V1.547h-3.094zm1.547 18.422a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094"
      />

      <path
        fill="#FAB908"
        d="M12.375 19.969a1.547 1.547 0 1 1 0 3.093 1.547 1.547 0 0 1 0-3.093"
      />

      <path fill="#FAB908" d="M10.828 23.203h3.094v-1.687h-3.094z" />
      <path
        fill="#34A853"
        d="M17.86 16.734a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094m0-5.484a1.547 1.547 0 1 1-.002 3.095 1.547 1.547 0 0 1 .001-3.095"
      />

      <path fill="#34A853" d="M16.313 18.281h3.093v-5.484h-3.093z" />
      <path
        fill="#FAB908"
        d="M12.375 6.328a1.547 1.547 0 1 1-.001 3.095 1.547 1.547 0 0 1 .001-3.095m0 9a1.547 1.547 0 1 1 0 3.094 1.547 1.547 0 0 1 0-3.094"
      />
    </g>
  </svg>
);

export default GooglePodcasts;
